import { ActionReducerMap } from '@ngrx/store';

import * as reducers from './reducers';

export interface AppState {
    Login: reducers.LoginTelPassState,
    RegisterUser: reducers.RegisterUserState,
    AuthUserPhone: reducers.AuthUserPhoneState,
    ValidJwtWa: reducers.ValidJwtWaState,
    ValidJwtBO: reducers.ValidJwtWaState,
    SendWebhook: reducers.SendWebhookState,
    Enko: reducers.EnkoState;
    sendCart: reducers.SendCartState;
    getOrders: reducers.ObtienePedidoState;
    GetmTienda: reducers.GetmTiendaState;
    ecommerceConfig: reducers.EcommerceConfigState;
    cartProducts: reducers.CartProductsState;
    orderDetail: reducers.CartProductsState;
    orders: reducers.PedidoState;
    products: reducers.ProductsListState;
    promosEcommerce: reducers.PromosEcommerceState;
    productsPromos: reducers.ProductsPromoState;
    cancelOrders: reducers.CancelaPedidoState;
    notifications: reducers.NotificationsState;
    readNotification: reducers.ReadNotificationState;
    cdgProgram: reducers.CDGProgramState;
    userData: reducers.IUserDataState;
    paraTi: reducers.ParaTiState;
    assistance: reducers.AssistanceState;
    listGames: reducers.ListGamesState;
    userInfoGames: reducers.UserInfoGamesState;
    RatingGame: reducers.RatingState;
    RatingByGame: reducers.RatingByGameState;
    SetSelectGame: reducers.SetSelectGameState;
    SaveGoing: reducers.SaveGoingState;
    StartGame: reducers.SaveGoingState;
    StatusLifesModal: reducers.StatusLifesState;
    SendConnection: reducers.SaveGoingState;
    AgreeLegals: reducers.LegalAgreeState;
    GetLegals: reducers.LegalGetState;
    LegalVersion: reducers.LegalStates;
    GeneralData: reducers.GeneralDataState;
    GeneralDataById: reducers.GeneralDataByIdState;
    Movements: reducers.MovementsState;
    cancelAccount: reducers.CancelAccountState;
    ejecucion: reducers.EjecucionState;
    ejecucionSend: reducers.SendEjecucionState;
    ejecucionInci: reducers.SendEjecucionInciState;
    ejecucionResult: reducers.ResultEjecucionState;
    ventasMes: reducers.VentasMesState;
    ventasTickestSeleccion: reducers.VentasTicketsMesSeleccionState;
    profile: reducers.ProfileState;
    UpdateProfile: reducers.UpdateProfileState;
    CurrentPass: reducers.CurrentPassState;
    NewPhone: reducers.NewPhoneState;
    resizeView: reducers.ResizeViewState;
    extrasLives: reducers.ExtrasLivesState;
    updatedUser: reducers.UpdatedState;
    resetUser: reducers.ReserUserState;
    gamificacion: reducers.GamificacionState;
    GAutoevaluacion: reducers.GamificacionState;
    GCuotas: reducers.GamificacionState;
    Configuraciones: reducers.IConfigDataState;
    TokenPremiados: reducers.TokenPremiadosState;
    SectionsPremiados: reducers.SectionsPremiadosState;
    PreRegisterUser: reducers.PreRegisterUserState;
    PhoneValid: reducers.RegisterUserState;
    ChangePass: reducers.RegisterUserState;
    Counters: reducers.CountersState;
    CountersSave: reducers.CountersSaveState;
    SendSmsPhone: reducers.SendSmsPhoneState;
    SendCodeVerify: reducers.SendCodeVerifyState;
    RefreshAuthToken: reducers.RefreshAuthTokenState;
    Modal: reducers.ModalState;
    Enfriadores: reducers.EnfriadoresState;
    CatalogoCP: reducers.CatalogoCPState;
    CatalogoReasons: reducers.CatalogoReasonsState;
    createTicket: reducers.CreateTicketState;
    cancelTicket: reducers.CancelTicketState;
    getTicketActivo: reducers.GetTicketActivoState;
    updateTicket: reducers.UpdateTicketState;
    contactProgram: reducers.ContactProgramState;
    contentCustomersV1: reducers.ContentCustomerState;
    rateOurAnswer: reducers.RateOurAnswerState;
    muralData: reducers.MuralDataState;
    privacyNotice: reducers.PrivacyNoticeState;
    profileConfig: reducers.ProfileConfigState;
    contactInfo: reducers.ContactInfoState;
    inicioApp: reducers.InicioAppState;
    mechanicsProgram: reducers.MechanicsProgramState;
    clientProgram: reducers.ClientProgramState;
    termsAndConditions: reducers.TermsAndConditionsState;
    questions: reducers.QuestionsState;
}

export const AppReducers: ActionReducerMap<AppState> = {
    Login: reducers.LoginTelPassReducer,
    RegisterUser: reducers.RegisterUserReducer,
    AuthUserPhone: reducers.AuthUserPhoneReducer,
    ValidJwtWa: reducers.ValidJwtWaReducer,
    ValidJwtBO: reducers.ValidJwtBOReducer,
    SendWebhook: reducers.sendWebhookReducer,
    Enko: reducers.EnkoReducer,
    sendCart: reducers.sendCartReducer,
    getOrders: reducers.obtienePedidoReducer,
    GetmTienda: reducers.getmTiendaReducer,
    ecommerceConfig: reducers.ecommerceConfigReducer,
    cartProducts: reducers.cartProductsReducer,
    orderDetail: reducers.orderDetailReducer,
    orders: reducers.pedidoReducer,
    products: reducers.productsReducer,
    promosEcommerce: reducers.promosEcommerceReducer,
    productsPromos: reducers.productsPromoReducer,
    cancelOrders: reducers.cancelPedidoReducer,
    notifications: reducers.NotificationsReducer,
    readNotification: reducers.ReadNotificationReducer,
    cdgProgram: reducers.CDGProgramReducer,
    userData: reducers.UserDataReducer,
    paraTi: reducers.ParaTiReducer,
    assistance: reducers.AssistanceReducer,
    listGames: reducers.ListGamesReducer,
    userInfoGames: reducers.UserInfoGamesReducer,
    RatingGame: reducers.RatingReducer,
    RatingByGame: reducers.RatingByGameReducer,
    SetSelectGame: reducers.SetSelectGameReducer,
    SaveGoing: reducers.SaveGoingReducer,
    StartGame: reducers.StartGameReducer,
    StatusLifesModal: reducers.StatusLifesModalReducer,
    SendConnection: reducers.SendConnectionReducer,
    AgreeLegals: reducers.LegalAgreeReducer,
    GetLegals: reducers.LegalGetReducer,
    LegalVersion: reducers.LegalVersionReducer,
    GeneralData: reducers.GeneralDataReducer,
    GeneralDataById: reducers.GeneralDataByIdReducer,
    Movements: reducers.MovementsReducer,
    cancelAccount: reducers.CancelAccountReducer,
    ejecucion: reducers.EjecucionReducer,
    ejecucionSend: reducers.SendEjecucionReducer,
    ejecucionInci: reducers.SendEjecucionInciReducer,
    ejecucionResult: reducers.ResultEjecucionReducer,
    ventasMes: reducers.VentasMesReducer,
    ventasTickestSeleccion: reducers.VentasTicketsMesSeleccionReducer,
    profile: reducers.ProfileReducer,
    UpdateProfile: reducers.UpdateProfileReducer,
    CurrentPass: reducers.CurrentPassReducer,
    NewPhone: reducers.NewPhoneReducer,
    resizeView: reducers.resizeViewReducer,
    extrasLives: reducers.ExtrasLivesReducer,
    updatedUser: reducers.UpdatedUserReducer,
    resetUser: reducers.ResetUserReducer,
    gamificacion: reducers.GamificacionReducer,
    GAutoevaluacion: reducers.GamificacionReducer,
    GCuotas: reducers.GamificacionReducer,
    Configuraciones: reducers.ConfigDataReducer,
    TokenPremiados: reducers.TokenPremiadosReducer,
    SectionsPremiados: reducers.SectionsPremiadosReducer,
    PreRegisterUser: reducers.PreRegisterUserReducer,
    PhoneValid: reducers.PhoneValidReducer,
    ChangePass: reducers.ChangePassReducer,
    Counters: reducers.CountersReducer,
    CountersSave: reducers.CountersSaveReducer,
    SendSmsPhone: reducers.SendSmsPhoneReducer,
    SendCodeVerify: reducers.SendCodeVerifyReducer,
    RefreshAuthToken: reducers.RefreshAuthTokenReducer,
    Enfriadores: reducers.enfriadoresReducer,
    Modal: reducers.ModalReducer,
    CatalogoCP: reducers.CatalogoCPReducer,
    CatalogoReasons: reducers.CatalogoReasonsReducer,
    createTicket: reducers.CreateTicketReducer,
    cancelTicket: reducers.CancelTicketReducer,
    getTicketActivo: reducers.GetTicketActivoReducer,
    updateTicket: reducers.UpdateTicketReducer,
    contactProgram: reducers.ContactProgramReducer,
    contentCustomersV1: reducers.ContentCustomerReducer,
    rateOurAnswer: reducers.RateOurAnswerReducer,
    muralData: reducers.MuralDataReducer,
    privacyNotice: reducers.PrivacyNoticeReducer,
    profileConfig: reducers.ProfileConfigReducer,
    contactInfo: reducers.ContactInfoReducer,
    inicioApp: reducers.InicioAppReducer,
    mechanicsProgram: reducers.MechanicsProgramReducer,
    clientProgram: reducers.ClientProgramReducer,
    termsAndConditions: reducers.TermsAndConditionsReducer,
    questions: reducers.QuestionsReducer,
};

export type AppReducerState = 'products' | 'cartProducts'
    | 'promosEcommerce' | 'productsPromos' | 'orders'
    | 'getOrders' | 'cancelOrders' | 'notifications'
    | 'readNotification' | 'cdgProgram' | 'userData'
    | 'paraTi' | 'assistance' | 'listGames' | 'userInfoGames' | 'RatingGame'
    | 'RatingByGame' | 'SetSelectGame' | 'SaveGoing' | 'StartGame'
    | 'StatusLifesModal' | 'SendConnection'
    | 'AgreeLegals' | 'GetLegals' | 'LegalVersion'
    | 'GeneralData' | 'GeneralDataById' | 'Movements'
    | 'cancelAccount' | 'ejecucion' | 'ejecucionSend'
    | 'ejecucionInci' | 'ejecucionResult' | 'ventasMes' | 'ventasTickestSeleccion'
    | 'profile' | 'UpdateProfile' | 'CurrentPass' | 'NewPhone'
    | 'resizeView' | 'extrasLives' | 'updatedUser' | 'orderDetail'
    | 'sendCart' | 'resetUser' | 'Enko' | 'SendWebhook' | 'ValidJwtWa' | 'ValidJwtBO'
    | 'AuthUserPhone' | 'Login' | 'RegisterUser' | 'GetLegals'
    | 'gamificacion' | 'GAutoevaluacion' | 'GCuotas' | 'Configuraciones'
    | 'TokenPremiados' | 'SectionsPremiados' | 'PreRegisterUser'
    | 'PhoneValid' | 'ChangePass' | 'Counters' | 'CountersSave'
    | 'SendSmsPhone' | 'SendCodeVerify' | 'RefreshAuthToken'
    | 'CatalogoCP' | 'createTicket' | 'cancelTicket' | 'getTicketActivo' | 'updateTicket'
    | 'Enfriadores' | 'Modal'
    | 'ecommerceConfig' | 'GetmTienda' | 'contactProgram' | 'contentCustomersV1'
    | 'rateOurAnswer' | 'muralData' | 'privacyNotice' | 'profileConfig'
    | 'contactInfo' | 'inicioApp' | 'mechanicsProgram'
    | 'clientProgram' | 'termsAndConditions' | 'questions'

    ;
